/**
 * GrowOpsPage - Admin Management Dashboard
 *
 * 4-tab management interface:
 * Planos, Assinaturas, Usuários, Auditoria
 */

import React, { useState } from 'react';
import AdminPlansTab from '@/components/admin/AdminPlansTab';
import AdminSubscriptionsTab from '@/components/admin/AdminSubscriptionsTab';
import AdminUsersTab from '@/components/admin/AdminUsersTab';
import AdminAuditTab from '@/components/admin/AdminAuditTab';
import { cn } from '@/lib/utils';

type ManagementTab = 'plans' | 'subscriptions' | 'users' | 'audit';

const TABS: { id: ManagementTab; label: string }[] = [
  { id: 'plans', label: 'Planos' },
  { id: 'subscriptions', label: 'Assinaturas' },
  { id: 'users', label: 'Usuários' },
  { id: 'audit', label: 'Auditoria' },
];

const GrowOpsPage: React.FC = () => {
  const [activeTab, setActiveTab] = useState<ManagementTab>('plans');

  return (
    <div className="max-w-7xl mx-auto p-6 space-y-6">
      <h1 className="text-2xl font-bold text-foreground">Grow Ops</h1>

      <div className="flex gap-1 border-b border-border overflow-x-auto">
        {TABS.map((tab) => (
          <button
            key={tab.id}
            onClick={() => setActiveTab(tab.id)}
            className={cn(
              'px-4 py-2.5 text-sm font-medium border-b-2 -mb-px transition-colors whitespace-nowrap shrink-0',
              activeTab === tab.id
                ? 'border-primary text-primary'
                : 'border-transparent text-muted-foreground hover:text-foreground',
            )}
          >
            {tab.label}
          </button>
        ))}
      </div>

      {activeTab === 'plans' && <AdminPlansTab />}
      {activeTab === 'subscriptions' && <AdminSubscriptionsTab />}
      {activeTab === 'users' && <AdminUsersTab />}
      {activeTab === 'audit' && <AdminAuditTab />}
    </div>
  );
};

export default GrowOpsPage;
